import { RadioOption } from '@form';
import {
  IntensityLineOptionType,
  LossesOrigins,
  LossesPercentages,
  PowerOptionType,
  VtnOptionType,
  WaveQualityOptionType,
} from '../models/form.models';

const REMOTE_AND_LINES_OPTIONS: RadioOption[] = [
  {
    label: 'CHARTS.INTENSITY_LINE.OPTION_1',
    value: 'rsabt',
  },
  {
    label: 'CHARTS.INTENSITY_LINE.OPTION_2',
    value: 'lines',
  },
];

export const INTENSITY_LINE_SELECTOR_DEFAULT_VALUE: IntensityLineOptionType =
  'rsabt';
export const INTENSITY_LINE_SELECTOR_OPTIONS: RadioOption[] =
  REMOTE_AND_LINES_OPTIONS;

const LOSSES_PERCENTAGE_OPTIONS: RadioOption[] = [
  {
    label: 'CHARTS.LOSSES.PERCENTAGE.OPTION_1',
    value: '85',
  },
  {
    label: 'CHARTS.LOSSES.PERCENTAGE.OPTION_2',
    value: '90',
  },
  {
    label: 'CHARTS.LOSSES.PERCENTAGE.OPTION_3',
    value: '95',
  },
  {
    label: 'CHARTS.LOSSES.PERCENTAGE.OPTION_4',
    value: '100',
  },
];

const LOSSES_ORIGIN_OPTIONS: RadioOption[] = [
  {
    label: 'CHARTS.LOSSES.ORIGIN.OPTION_1',
    value: 'sabt',
  },
  {
    label: 'CHARTS.LOSSES.ORIGIN.OPTION_2',
    value: 'supervisor',
  },
];

export const LOSSES_ORIGIN_DEFAULT_VALUE: LossesOrigins = 'sabt';
export const LOSSES_ORIGIN_SELECTOR_OPTIONS: RadioOption[] =
  LOSSES_ORIGIN_OPTIONS;
export const LOSSES_PERCENTAGE_SELECTOR_DEFAULT_VALUE: LossesPercentages = '85';
export const LOSSES_PERCENTAGE_SELECTOR_OPTIONS: RadioOption[] =
  LOSSES_PERCENTAGE_OPTIONS;

export const TEMPERATURE_SELECTOR_DEFAULT_VALUE: IntensityLineOptionType =
  'rsabt';
export const TEMPERATURE_SELECTOR_OPTIONS: RadioOption[] =
  REMOTE_AND_LINES_OPTIONS;

export const WAVE_QUALITY_SELECTOR_DEFAULT_VALUE: WaveQualityOptionType =
  'frequency';
export const WAVE_QUALITY_SELECTOR_OPTIONS: RadioOption[] = [
  {
    label: 'CHARTS.WAVE_QUALITY.OPTION_1',
    value: 'frequency',
  },
  {
    label: 'CHARTS.WAVE_QUALITY.OPTION_2',
    value: 'flicker',
  },
  {
    label: 'CHARTS.WAVE_QUALITY.OPTION_3',
    value: 'voltage_imbalance',
  },
  {
    label: 'CHARTS.WAVE_QUALITY.OPTION_4',
    value: 'harmonics',
  },
];

export const VTN_SELECTOR_DEFAULT_VALUE: VtnOptionType = 'temperature';
export const VTN_SELECTOR_OPTIONS: RadioOption[] = [
  {
    label: 'CHARTS.VTN.OPTION_1',
    value: 'temperature',
  },
  {
    label: 'CHARTS.VTN.OPTION_2',
    value: 'voltage',
  },
];

export const POWER_SELECTOR_DEFAULT_VALUE: PowerOptionType = 'incoming_active';
export const POWER_SELECTOR_OPTIONS: RadioOption[] = [
  {
    label: 'CHARTS.POWER.OPTION_1',
    value: 'incoming_active',
  },
  {
    label: 'CHARTS.POWER.OPTION_2',
    value: 'outgoing_active',
  },
  {
    label: 'CHARTS.POWER.OPTION_3',
    value: 'incoming_reactive',
  },
  {
    label: 'CHARTS.POWER.OPTION_4',
    value: 'outgoing_reactive',
  },
];
